import React from 'react';
import styled from 'styled-components';

import { Divider, Drawer } from 'antd';
import type { DrawerProps } from 'antd';

import appleMapsIcon from '../../img/mapsIcons/apple_maps.png';
import googleMapsIcon from '../../img/mapsIcons/google_maps.png';

interface iOSMapDrawerProps {
  visible: boolean;
  setVisible: DrawerProps['onClose'];
  destinationAddress: string;
}

const MobileMapsDrawer: React.FC<iOSMapDrawerProps> = ({
  visible,
  setVisible,
  destinationAddress,
}) => (
    <Drawer
      drawerStyle={{
        background: 'white',
        borderRadius: '32px 32px 0 0',
      }}
      height="150"
      placement="bottom"
      open={visible}
      closable={false}
      onClose={setVisible}
    >
      <MapButtonContainer
        onClick={() => {
          window.open(`http://maps.apple.com/?daddr=${destinationAddress}`);
        }}
      >
        <MapImageContainer>
          <img src={appleMapsIcon} alt="apple maps" />
        </MapImageContainer>
        Apple Maps
      </MapButtonContainer>
      <Divider />
      <MapButtonContainer
        onClick={() => {
          window.open(`comgooglemaps://?daddr=${destinationAddress}`);
        }}
      >
        <MapImageContainer>
          <img src={googleMapsIcon} alt="google maps" />
        </MapImageContainer>
        Google Maps
      </MapButtonContainer>
    </Drawer>
  );

export default MobileMapsDrawer;

const MapButtonContainer = styled.div`
  display: flex;
  gap: 16px;
`;

const MapImageContainer = styled.div`
  display: flex;
  width: 25px;
  height: 25px;
  justify-content: center;
`;
